/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83290a114618bdfa1ff9d24e32a6f1b1>>
 * @codegenCommand yarn build tokens
 */
var tokens = {
  'color.text.accent.blue': '--ds-text-accent-blue',
  'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
  'color.text.accent.red': '--ds-text-accent-red',
  'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
  'color.text.accent.orange': '--ds-text-accent-orange',
  'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
  'color.text.accent.yellow': '--ds-text-accent-yellow',
  'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
  'color.text.accent.green': '--ds-text-accent-green',
  'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
  'color.text.accent.purple': '--ds-text-accent-purple',
  'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
  'color.text.accent.teal': '--ds-text-accent-teal',
  'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
  'color.text.accent.magenta': '--ds-text-accent-magenta',
  'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
  'color.text.accent.gray': '--ds-text-accent-gray',
  'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
  'color.text': '--ds-text',
  'color.text.subtle': '--ds-text-subtle',
  'color.text.subtlest': '--ds-text-subtlest',
  'color.text.disabled': '--ds-text-disabled',
  'color.text.inverse': '--ds-text-inverse',
  'color.text.brand': '--ds-text-brand',
  'color.text.selected': '--ds-text-selected',
  'color.text.danger': '--ds-text-danger',
  'color.text.warning': '--ds-text-warning',
  'color.text.warning.inverse': '--ds-text-warning-inverse',
  'color.text.success': '--ds-text-success',
  'color.text.discovery': '--ds-text-discovery',
  'color.text.information': '--ds-text-information',
  'color.text.highEmphasis': '--ds-text-highEmphasis',
  'color.text.link.pressed': '--ds-text-link-pressed',
  'color.text.link.resting': '--ds-text-link-resting',
  'color.text.lowEmphasis': '--ds-text-lowEmphasis',
  'color.text.mediumEmphasis': '--ds-text-mediumEmphasis',
  'color.text.onBold': '--ds-text-onBold',
  'color.text.onBoldWarning': '--ds-text-onBoldWarning',
  'color.icon.accent.blue': '--ds-icon-accent-blue',
  'color.icon.accent.red': '--ds-icon-accent-red',
  'color.icon.accent.orange': '--ds-icon-accent-orange',
  'color.icon.accent.yellow': '--ds-icon-accent-yellow',
  'color.icon.accent.green': '--ds-icon-accent-green',
  'color.icon.accent.purple': '--ds-icon-accent-purple',
  'color.icon.accent.teal': '--ds-icon-accent-teal',
  'color.icon.accent.magenta': '--ds-icon-accent-magenta',
  'color.icon.accent.gray': '--ds-icon-accent-gray',
  'color.icon': '--ds-icon',
  'color.icon.subtle': '--ds-icon-subtle',
  'color.icon.inverse': '--ds-icon-inverse',
  'color.icon.disabled': '--ds-icon-disabled',
  'color.icon.brand': '--ds-icon-brand',
  'color.icon.selected': '--ds-icon-selected',
  'color.icon.danger': '--ds-icon-danger',
  'color.icon.warning': '--ds-icon-warning',
  'color.icon.warning.inverse': '--ds-icon-warning-inverse',
  'color.icon.success': '--ds-icon-success',
  'color.icon.discovery': '--ds-icon-discovery',
  'color.icon.information': '--ds-icon-information',
  'color.border.accent.blue': '--ds-border-accent-blue',
  'color.border.accent.red': '--ds-border-accent-red',
  'color.border.accent.orange': '--ds-border-accent-orange',
  'color.border.accent.yellow': '--ds-border-accent-yellow',
  'color.border.accent.green': '--ds-border-accent-green',
  'color.border.accent.purple': '--ds-border-accent-purple',
  'color.border.accent.teal': '--ds-border-accent-teal',
  'color.border.accent.magenta': '--ds-border-accent-magenta',
  'color.border.accent.gray': '--ds-border-accent-gray',
  'color.border': '--ds-border',
  'color.border.bold': '--ds-border-bold',
  'color.border.inverse': '--ds-border-inverse',
  'color.border.focused': '--ds-border-focused',
  'color.border.input': '--ds-border-input',
  'color.border.disabled': '--ds-border-disabled',
  'color.border.brand': '--ds-border-brand',
  'color.border.selected': '--ds-border-selected',
  'color.border.danger': '--ds-border-danger',
  'color.border.warning': '--ds-border-warning',
  'color.border.success': '--ds-border-success',
  'color.border.discovery': '--ds-border-discovery',
  'color.border.information': '--ds-border-information',
  'color.border.focus': '--ds-border-focus',
  'color.border.neutral': '--ds-border-neutral',
  'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
  'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
  'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
  'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
  'color.background.accent.blue': '--ds-background-accent-blue',
  'color.background.accent.blue.bold': '--ds-background-accent-blue-bold',
  'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
  'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
  'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
  'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
  'color.background.accent.red': '--ds-background-accent-red',
  'color.background.accent.red.bold': '--ds-background-accent-red-bold',
  'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
  'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
  'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
  'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
  'color.background.accent.orange': '--ds-background-accent-orange',
  'color.background.accent.orange.bold': '--ds-background-accent-orange-bold',
  'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
  'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
  'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
  'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
  'color.background.accent.yellow': '--ds-background-accent-yellow',
  'color.background.accent.yellow.bold': '--ds-background-accent-yellow-bold',
  'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
  'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
  'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
  'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
  'color.background.accent.green': '--ds-background-accent-green',
  'color.background.accent.green.bold': '--ds-background-accent-green-bold',
  'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
  'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
  'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
  'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
  'color.background.accent.teal': '--ds-background-accent-teal',
  'color.background.accent.teal.bold': '--ds-background-accent-teal-bold',
  'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
  'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
  'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
  'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
  'color.background.accent.purple': '--ds-background-accent-purple',
  'color.background.accent.purple.bold': '--ds-background-accent-purple-bold',
  'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
  'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
  'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
  'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
  'color.background.accent.magenta': '--ds-background-accent-magenta',
  'color.background.accent.magenta.bold': '--ds-background-accent-magenta-bold',
  'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
  'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
  'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
  'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
  'color.background.disabled': '--ds-background-disabled',
  'color.background.inverse.subtle': '--ds-background-inverse-subtle',
  'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
  'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
  'color.background.inverse': '--ds-background-inverse',
  'color.background.input': '--ds-background-input',
  'color.background.input.hovered': '--ds-background-input-hovered',
  'color.background.input.pressed': '--ds-background-input-pressed',
  'color.background.neutral': '--ds-background-neutral',
  'color.background.neutral.hovered': '--ds-background-neutral-hovered',
  'color.background.neutral.pressed': '--ds-background-neutral-pressed',
  'color.background.neutral.subtle': '--ds-background-neutral-subtle',
  'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
  'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
  'color.background.neutral.bold': '--ds-background-neutral-bold',
  'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
  'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
  'color.background.brand.bold': '--ds-background-brand-bold',
  'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
  'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
  'color.background.brand': '--ds-background-brand',
  'color.background.brand.hovered': '--ds-background-brand-hovered',
  'color.background.brand.pressed': '--ds-background-brand-pressed',
  'color.background.selected': '--ds-background-selected',
  'color.background.selected.hovered': '--ds-background-selected-hovered',
  'color.background.selected.pressed': '--ds-background-selected-pressed',
  'color.background.selected.bold': '--ds-background-selected-bold',
  'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
  'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
  'color.background.selected.resting': '--ds-background-selected-resting',
  'color.background.selected.hover': '--ds-background-selected-hover',
  'color.background.danger': '--ds-background-danger',
  'color.background.danger.hovered': '--ds-background-danger-hovered',
  'color.background.danger.pressed': '--ds-background-danger-pressed',
  'color.background.danger.bold': '--ds-background-danger-bold',
  'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
  'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
  'color.background.warning': '--ds-background-warning',
  'color.background.warning.hovered': '--ds-background-warning-hovered',
  'color.background.warning.pressed': '--ds-background-warning-pressed',
  'color.background.warning.bold': '--ds-background-warning-bold',
  'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
  'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
  'color.background.success': '--ds-background-success',
  'color.background.success.hovered': '--ds-background-success-hovered',
  'color.background.success.pressed': '--ds-background-success-pressed',
  'color.background.success.bold': '--ds-background-success-bold',
  'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
  'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
  'color.background.discovery': '--ds-background-discovery',
  'color.background.discovery.hovered': '--ds-background-discovery-hovered',
  'color.background.discovery.pressed': '--ds-background-discovery-pressed',
  'color.background.discovery.bold': '--ds-background-discovery-bold',
  'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
  'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
  'color.background.information': '--ds-background-information',
  'color.background.information.hovered': '--ds-background-information-hovered',
  'color.background.information.pressed': '--ds-background-information-pressed',
  'color.background.information.bold': '--ds-background-information-bold',
  'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
  'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
  'color.background.blanket': '--ds-background-blanket',
  'color.background.boldBrand.hover': '--ds-background-boldBrand-hover',
  'color.background.boldBrand.pressed': '--ds-background-boldBrand-pressed',
  'color.background.boldBrand.resting': '--ds-background-boldBrand-resting',
  'color.background.boldDanger.hover': '--ds-background-boldDanger-hover',
  'color.background.boldDanger.pressed': '--ds-background-boldDanger-pressed',
  'color.background.boldDanger.resting': '--ds-background-boldDanger-resting',
  'color.background.boldDiscovery.hover': '--ds-background-boldDiscovery-hover',
  'color.background.boldDiscovery.pressed': '--ds-background-boldDiscovery-pressed',
  'color.background.boldDiscovery.resting': '--ds-background-boldDiscovery-resting',
  'color.background.boldNeutral.hover': '--ds-background-boldNeutral-hover',
  'color.background.boldNeutral.pressed': '--ds-background-boldNeutral-pressed',
  'color.background.boldNeutral.resting': '--ds-background-boldNeutral-resting',
  'color.background.boldSuccess.hover': '--ds-background-boldSuccess-hover',
  'color.background.boldSuccess.pressed': '--ds-background-boldSuccess-pressed',
  'color.background.boldSuccess.resting': '--ds-background-boldSuccess-resting',
  'color.background.boldWarning.hover': '--ds-background-boldWarning-hover',
  'color.background.boldWarning.pressed': '--ds-background-boldWarning-pressed',
  'color.background.boldWarning.resting': '--ds-background-boldWarning-resting',
  'color.background.card': '--ds-background-card',
  'color.background.default': '--ds-background-default',
  'color.background.overlay': '--ds-background-overlay',
  'color.background.subtleBorderedNeutral.pressed': '--ds-background-subtleBorderedNeutral-pressed',
  'color.background.subtleBorderedNeutral.resting': '--ds-background-subtleBorderedNeutral-resting',
  'color.background.subtleBrand.hover': '--ds-background-subtleBrand-hover',
  'color.background.subtleBrand.pressed': '--ds-background-subtleBrand-pressed',
  'color.background.subtleBrand.resting': '--ds-background-subtleBrand-resting',
  'color.background.subtleDanger.hover': '--ds-background-subtleDanger-hover',
  'color.background.subtleDanger.pressed': '--ds-background-subtleDanger-pressed',
  'color.background.subtleDanger.resting': '--ds-background-subtleDanger-resting',
  'color.background.subtleDiscovery.hover': '--ds-background-subtleDiscovery-hover',
  'color.background.subtleDiscovery.pressed': '--ds-background-subtleDiscovery-pressed',
  'color.background.subtleDiscovery.resting': '--ds-background-subtleDiscovery-resting',
  'color.background.subtleNeutral.hover': '--ds-background-subtleNeutral-hover',
  'color.background.subtleNeutral.pressed': '--ds-background-subtleNeutral-pressed',
  'color.background.subtleNeutral.resting': '--ds-background-subtleNeutral-resting',
  'color.background.subtleSuccess.hover': '--ds-background-subtleSuccess-hover',
  'color.background.subtleSuccess.pressed': '--ds-background-subtleSuccess-pressed',
  'color.background.subtleSuccess.resting': '--ds-background-subtleSuccess-resting',
  'color.background.subtleWarning.hover': '--ds-background-subtleWarning-hover',
  'color.background.subtleWarning.pressed': '--ds-background-subtleWarning-pressed',
  'color.background.subtleWarning.resting': '--ds-background-subtleWarning-resting',
  'color.background.sunken': '--ds-background-sunken',
  'color.background.transparentNeutral.hover': '--ds-background-transparentNeutral-hover',
  'color.background.transparentNeutral.pressed': '--ds-background-transparentNeutral-pressed',
  'color.blanket': '--ds-blanket',
  'color.blanket.selected': '--ds-blanket-selected',
  'color.blanket.danger': '--ds-blanket-danger',
  'color.interaction.hovered': '--ds-interaction-hovered',
  'color.interaction.pressed': '--ds-interaction-pressed',
  'color.interaction.inverse.hovered': '--ds-interaction-inverse-hovered',
  'color.interaction.inverse.pressed': '--ds-interaction-inverse-pressed',
  'color.skeleton': '--ds-skeleton',
  'color.skeleton.subtle': '--ds-skeleton-subtle',
  'color.link': '--ds-link',
  'color.link.pressed': '--ds-link-pressed',
  'color.accent.boldBlue': '--ds-accent-boldBlue',
  'color.accent.boldGreen': '--ds-accent-boldGreen',
  'color.accent.boldOrange': '--ds-accent-boldOrange',
  'color.accent.boldPurple': '--ds-accent-boldPurple',
  'color.accent.boldRed': '--ds-accent-boldRed',
  'color.accent.boldTeal': '--ds-accent-boldTeal',
  'color.accent.subtleBlue': '--ds-accent-subtleBlue',
  'color.accent.subtleGreen': '--ds-accent-subtleGreen',
  'color.accent.subtleMagenta': '--ds-accent-subtleMagenta',
  'color.accent.subtleOrange': '--ds-accent-subtleOrange',
  'color.accent.subtlePurple': '--ds-accent-subtlePurple',
  'color.accent.subtleRed': '--ds-accent-subtleRed',
  'color.accent.subtleTeal': '--ds-accent-subtleTeal',
  'color.iconBorder.brand': '--ds-iconBorder-brand',
  'color.iconBorder.danger': '--ds-iconBorder-danger',
  'color.iconBorder.discovery': '--ds-iconBorder-discovery',
  'color.iconBorder.success': '--ds-iconBorder-success',
  'color.iconBorder.warning': '--ds-iconBorder-warning',
  'color.overlay.hover': '--ds-overlay-hover',
  'color.overlay.pressed': '--ds-overlay-pressed',
  'shadow.card': '--ds-card',
  'shadow.overlay': '--ds-overlay',
  'elevation.shadow.raised': '--ds-shadow-raised',
  'elevation.shadow.overflow': '--ds-shadow-overflow',
  'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
  'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
  'elevation.shadow.overlay': '--ds-shadow-overlay',
  'elevation.surface': '--ds-surface',
  'elevation.surface.hovered': '--ds-surface-hovered',
  'elevation.surface.pressed': '--ds-surface-pressed',
  'elevation.surface.sunken': '--ds-surface-sunken',
  'elevation.surface.raised': '--ds-surface-raised',
  'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
  'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
  'elevation.surface.overlay': '--ds-surface-overlay',
  'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
  'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
  'opacity.disabled': '--ds-opacity-disabled',
  'opacity.loading': '--ds-opacity-loading',
  'utility.UNSAFE_util.transparent': '--ds-UNSAFE_util-transparent',
  'utility.UNSAFE_util.MISSING_TOKEN': '--ds-UNSAFE_util-MISSING_TOKEN'
};
export default tokens;